import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: {
    changed: false,
    channel: null,
    user: null,
    tags: [],
  },

  search: {
    term: null,
  },

  sort: {
    element: 'created_at',
    order: 'DESC',
  },
};

const { reducer, actions } = createSlice({
  name: 'mcoTemplates',
  initialState,

  reducers: {
    applyFilter: (state, { payload: { type, value } }) => {
      state.search.term = '';
      state.filters[type] = value;
      state.filters.changed = true;
    },

    resetFilter: (state) => {
      state.filters = { ...initialState.filters };
    },

    applySort: (state, { payload: { element, order } }) => {
      state.search.term = '';
      state.sort.element = element;
      state.sort.order = order;
    },

    applySearchTerm: (state, { payload }) => {
      state.filters = { ...initialState.filters };
      state.search.term = payload?.searchTerm;
    },
  },
});

export default reducer;
export const { applyFilter, resetFilter, applySort, applySearchTerm } = actions;
